import React, { Component } from 'react';
import { Container, Card } from 'semantic-ui-react';

import ExperienceList from "./ExperienceList";

export default class Experience extends Component {
    render() {
        return (
            <Container id="experience" fluid>
                <Card fluid>
                    <Card.Content header="Work Experience" />
                    <Card.Content description={<ExperienceList />} />
                </Card>
            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Experience.js